import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="border-t border-primary/10 bg-background py-20" aria-labelledby="faq-title" data-id="element-47" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-48" data-mp="2a1ysx0qjzaau">
        <SectionHeading id="faq-title" data-id="element-49" data-mp="2a1qh7c662b18">Frequently Asked Questions</SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-50" data-mp="2546zu3e69i52">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-xl border bg-surface transition-colors duration-150 ease-out ${isOpen ? 'border-primary' : 'border-primary/25'}`} data-id="element-51" data-mp="205vpzsnvn7mu" data-mpi={index}>
                <h3 className="font-sans" data-id="element-52" data-mp="omt4y58zslke">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-foreground transition-colors duration-150 ease-out hover:bg-surface-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-accent/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-53" data-mp="jpjf4ohoy7w1">
                    <span data-id="element-54" data-mp="1fodmw7s4d0np">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-primary transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-55" data-mp="1fnccm5ixgi71" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-56" data-mp="16q1xg92zo8wu">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-57" data-mp="s042naak0kyo">
                      <p className="border-t border-primary/15 px-5 py-4 leading-relaxed text-muted sm:px-6" data-id="element-58" data-mp="2pmwutk5mc35u">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}